import { useSignupForm } from './Form.h'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import { FormProvider } from 'react-hook-form'
import { Link as RRDLink } from 'react-router-dom'
import FormTextField from '@shared/components/FormTextField'

export default function Signup() {
    const {
        form,
        mutate
    } = useSignupForm()

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(mutate)}>
                <Stack sx={{display: 'flex'}}>
                    <Typography variant="h5">إنشاء حساب</Typography>
                    <Link
                        component={RRDLink}
                        to='/auth/login'
                        underline='none'
                    >هل تملك حساباً؟ دخول</Link>
                    <br />
                    <Box sx={{
                        display: 'flex',
                        gap: 2
                    }}>
                        <FormTextField
                            name='business'
                            label='اسم الشركة'
                        />
                        <FormTextField
                            name='name'
                            label='اسمك الكريم'
                        />
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        gap: 2
                    }}>
                        <FormTextField
                            name='email'
                            label='البريد الإلكتروني'
                            helperText='يفضل بريدك تبع الشركة.'
                        />
                        <FormTextField
                            name='phone_number'
                            label='رقم الهاتف (إختياري)'
                            helperText='يبدأ بـ +966'
                        />
                    </Box>
                    <FormTextField
                        name='password'
                        label='كلمة المرور'
                        type='password'
                    />
                    <br />
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        justifyContent: 'space-between'
                    }}>
                        <Button
                            type='submit'
                            variant='contained'
                            sx={{boxShadow: 0}}
                        >إنشاء حساب</Button>
                    </Box>
                </Stack>
            </form>
        </FormProvider>
    )
}